import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { List, Card, Button, message, Form, Input, Switch } from "antd";
import {
  SearchOutlined,
  CopyOutlined,
  FormOutlined,
  ShopOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import _, { identity } from "lodash";
import qs from "query-string";
import $ from "jquery";
import "./styles.module.scss";
import AppHelper from "libs/AppHelper";
import { API_HOST, GOOGLE_MAP_KEY } from "../../configs/env";
import whttp from "../../libs/whttp";
import classnames from "classnames";
import { __, sprintf } from "@wordpress/i18n";
const PLUGIN_ASSETS_URL = _.get(window, "VC_CONFIG.PLUGIN_ASSETS_URL");
const INDEX_URL = _.get(window, "VC_CONFIG.INDEX_URL");
const Locale = _.get(window, "VC_CONFIG.Locale");
const FormItem = Form.Item;
const stringToBr = (text) => {
  return _.map(_.split(text, "\n"), (line, idx) => (
    <Fragment key={idx}>
      {line}
      <br />
    </Fragment>
  ));
};

// 前端頁面
export default class BrandList extends Component {
  state = {
    tabType: "info",
    query: {
      cid: null,
      keyword: null,
    },
    brandInfo: undefined,
    listInfo: {
      current: 1, //目前頁數
      page_size: 10, //一頁幾筆
      total: 1, //以此query條件，總共幾筆資料
      rows: [],
    },
    vip: 0,
  };

  componentDidMount() {
    const query = AppHelper.getHashParamaters();
    this.loadConfig();
    this.loadData(query);
    this.loadBanner();
    this.setState({ query });
    this.GTM();
  }
  GTM = () => {
    var dataLayer = window.dataLayer || [];
    $(document).on("click", "#brand div a", function() {
      var $text = $(this).attr("alt");
      dataLayer.push({
        event: "brand_click",
        item: $text,
      });
    });
  };
  loadConfig = () => {
    this.setState({ isLoadingData: true });

    whttp.get(API_HOST + "/api/v1/system/configs", {}, (state, res) => {
      this.setState({ isLoadingData: false });
      const { code = 100, reason = "發生錯誤", data = {} } = res;

      if (state === false) {
        return this.setState({ message: "發生錯誤" });
      }

      if (code !== 200) {
        return this.setState({ message: reason });
      }

      this.setState({ options: data.options }, () => {
        this.refreshPicker();
      });
    });
  };

  loadData = (query = {}) => {
    this.setState({ isFetchData: true });
    whttp.sharedGet(
      API_HOST + `/api/v1/brands`,
      {
        page_size: "all",
        keyword: query.keyword,
      },
      (state, res) => {
        this.setState({ isFetchData: false });

        const { code = 100, reason = "發生錯誤", data = {} } = res;

        console.log("loadData", code, reason, data, res);

        if (state === false || code !== 200) {
          message.warning(reason);
          this.props.history.replace("/brands");
          return;
        }

        this.setState({ brandInfo: data.rows });
      }
    );
  };
  loadBanner = () => {
    this.setState({ isFetchData: true });

    whttp.sharedGet(
      API_HOST + `/api/v1/news?`,
      {
        "category_ids[]": 110,
      },
      (state, res) => {
        this.setState({ isFetchData: false });

        const { code = 100, reason = "發生錯誤", data = {} } = res;

        console.log("loadBanner", code, reason, data, res);

        if (state === false || code !== 200) {
          message.warning(reason);
          this.props.history.replace("/brands");
          return;
        }

        this.setState({ listInfo: data.rows });
      }
    );
  };
  refreshPicker = _.debounce(() => {
    $(".selectpicker").selectpicker("refresh");
  }, 1000);
  handleQueryUpdate = (key, value) => {
    const query = _.get(this, "state.query", {});
    _.set(query, key, value);
    this.setState({ query });
    window.location.href = this.getSearchPath(query);
  };
  getSearchPath = (query) => {
    if (Locale == "en_US")
      return (
        window.VC_CONFIG.INDEX_URL +
        `/brands-en/#` +
        qs.stringify(query, { skipNull: true })
      );
    return (
      window.VC_CONFIG.INDEX_URL +
      `/brands/#` +
      qs.stringify(query, { skipNull: true })
    );
  };
  render() {
    const tabType = _.get(this, "state.tabType", {});
    const options = _.get(this, "state.options", {});
    const query = _.get(this, "state.query", {});
    const vip = _.get(this, "state.vip");
    const brandInfo = _.get(this, "state.brandInfo", {});
    const listInfo = _.get(this, "state.listInfo");
    const categoryOptions = _.get(options, "food_categories", [])
      .concat(_.get(options, "brand_categories", []))
      .filter((categoryInfo) => !_.isEmpty(categoryInfo.items));
    const Local = _.get(window, "VC_CONFIG.Locale");
    let brand_categorys = categoryOptions;
    var keyword_ids = [];
    var keyword_cate = [];
    var vip_cate = [];
    if (query.cid) {
      brand_categorys = brand_categorys.filter(
        (categoryInfo) => categoryInfo.id == query.cid
      );
    }
    if (query.keyword) {
      _.map(brandInfo, (info) => {
        keyword_ids.push(info.id);
      });
      _.map(brand_categorys, (categoryInfo) => {
        _.map(_.get(categoryInfo, "items", []), (Info) => {
          if (
            _.find(keyword_ids, (id) => {
              return Info.id == id;
            }) &&
            !_.find(keyword_cate, (id) => {
              return categoryInfo.id == id;
            })
          ) {
            keyword_cate.push(categoryInfo.id);
          }
        });
      });
      brand_categorys = brand_categorys.filter((categoryInfo) =>
        _.find(keyword_cate, (id) => {
          return categoryInfo.id == id;
        })
      );
    }
    if (vip == 1) {
      _.map(brand_categorys, (categoryInfo) => {
        _.map(_.get(categoryInfo, "items", []), (Info) => {
          if (
            Info.is_vip == vip &&
            !_.find(vip_cate, (id) => {
              return categoryInfo.id == id;
            })
          ) {
            vip_cate.push(categoryInfo.id);
          }
        });
      });
      brand_categorys = brand_categorys.filter((categoryInfo) =>
        _.find(vip_cate, (id) => {
          return categoryInfo.id == id;
        })
      );
    }
    this.refreshPicker();
    return (
      <Fragment>
        <div class="bg-light">
          <div class="container">
            <div class="breadcrumb-wrap py-4 m-0">
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a
                      href={`${window.VC_CONFIG.INDEX_URL}${
                        Local == "en_US" ? "/en" : ""
                      }`}
                    >
                      {__("首頁", "cec-plugin-stores")}
                    </a>
                  </li>
                  <li class="breadcrumb-item">
                    <a
                      href={`${window.VC_CONFIG.INDEX_URL}/shopping-mall${
                        Local == "en_US" ? "-en" : ""
                      }`}
                    >
                      {__("購物中心", "cec-plugin-stores")}
                    </a>
                  </li>
                  <li class="breadcrumb-item">
                    <a
                      href={`${window.VC_CONFIG.INDEX_URL}/brands${
                        Local == "en_US" ? "-en" : ""
                      }`}
                    >
                      {__("合作品牌", "cec-plugin-stores")}
                    </a>
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
        <div class="banner-location">
          <div class="banner-image">
            {listInfo && _.get(_.head(listInfo), "images.0.url") && (
              <img src={`${_.get(_.head(listInfo), "images.0.url")}`} alt="" />
            )}
            {(!listInfo || !_.get(_.head(listInfo), "images.0.url")) && (
              <img
                src={`${PLUGIN_ASSETS_URL}img/banner/store/banner-brand.png`}
                alt=""
              />
            )}
          </div>
        </div>
        <main class="bg-light">
          <div class="container">
            <div class="map-filter-bar outer">
              <div class="row justify-content-center no-gutters mx-n2 pt-4">
                <div class="col-md-3 px-2">
                  <div className="form-group">
                    <select
                      className="form-select selectpicker"
                      name="category_id"
                      value={query.cid}
                      onChange={(e) =>
                        this.handleQueryUpdate("cid", e.target.value)
                      }
                    >
                      <option value={undefined} disabled>
                        {__("請選擇類別", "cec-plugin-stores")}
                      </option>
                      <option value="">
                        {__("所有類別", "cec-plugin-stores")}{" "}
                      </option>
                      {_.map(categoryOptions, (item) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div class="col-md-3 px-2">
                  <div className="form-group">
                    <Input
                      placeholder="搜尋名稱"
                      size="large"
                      style={{ height: "50px" }}
                      value={query.keyword}
                      onChange={(e) =>
                        this.handleQueryUpdate("keyword", e.target.value)
                      }
                    />
                  </div>
                </div>
                <div class="col-md-auto px-2">
                  <a
                    role="button"
                    className="btn btn-primary btn-search"
                    onClick={() => {
                      this.loadData(query);
                    }}
                  >
                    <i
                      className="icon-search mr-3 mr-md-0 "
                      style={{ color: "#FFFFFF" }}
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="d-flex align-items-md-center justify-content-between pt-4">
              <div class="ml-auto" style={{ padding: "20px" }}>
                <Switch
                  checkedChildren="vip特約商店"
                  unCheckedChildren="vip特約商店"
                  onChange={(value) => {
                    var val = 0;
                    if (value === true) val = 1;
                    else val = 0;
                    this.setState({ vip: val });
                  }}
                />
              </div>
            </div>
          </div>
          {_.map(brand_categorys, (categoryInfo) => (
            <div class="container" key={categoryInfo.id}>
              <h4 class="heading-title justify-content-center">
                {categoryInfo.name}
              </h4>
              <hr class="border-top border-navy mt-0 mb-4" />
              <div class="mb-5">
                <div id="brand" class="row">
                  {_.map(_.get(categoryInfo, "items", []), (Info) => {
                    if (
                      _.find(brandInfo, (brandInfo) => {
                        return brandInfo.id == Info.id;
                      }) &&
                      (vip == 0 ||
                        (vip == 1 && Info.is_vip && Info.is_vip == vip))
                    ) {
                      return (
                        <div class="col-4 col-md-3 col-lg-2 my-4">
                          <a
                            alt={Info.name}
                            role="button"
                            class="store-brand-logo-link"
                            href={`${INDEX_URL}/brand-info${
                              Locale == "en_US" ? "-en" : ""
                            }/?brand=${Info.name}`}
                          >
                            <img src={Info.image} alt={Info.name} />
                          </a>
                        </div>
                      );
                    }
                  })}
                </div>
              </div>
            </div>
          ))}
        </main>
      </Fragment>
    );
  }
}

// 編輯器
export class BrandListEditor extends Component {
  render() {
    return <div className="vu-blocks-editor">編輯器</div>;
  }
}



// WEBPACK FOOTER //
// ./src/blocks/brands/brand-list.js